<template>
  <div>
    <a href="https://wiki.guildwars2.com/wiki/Defiance_bar">
    <div class="image is-24x24 is-inline-block">
      <img src="https://wiki.guildwars2.com/images/4/49/Unshakable2.png" alt="Defiance bar" title="Defiance bar">
    </div>
    <div class="breakbar-inner teal">
      {{ size }}
    </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "DefianceBar",
  props: ["size"]
}
</script>

<style scoped>
.breakbar-inner {
  display: inline-block;
  vertical-align: top;
  margin-left: -24px;
  margin-top: 6px;
  height: 20px;
  width: 100%;
  border: 1px solid black;
  line-height: 19px;
  color: white;
  font-weight: bold;
  text-align: center;
  text-shadow: 0 0 2px black;
}
.teal {
  background-color: #4aaba5
}
</style>